import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import {useSelector} from "react-redux";
import {database} from "../firebase";


const users = [{
        id: 1,
        photo: "./assets/images/user1.jpg",
        name: "Aliqa Macale",
        tagname: "AliqaMacale",
        connect: "http://www.google.com"
    },{
        id: 2,
        photo: "./assets/images/user2.jpg",
        name: "Seary Victor",
        tagname: "SearyVictor",
        connect: "http://www.google.com"
    },{
        id: 3,
        photo: "./assets/images/user3.jpg",
        name: "John Steere",
        tagname: "JohnSteere",
        connect: "http://www.google.com"
    },{
        id: 4,
        photo: "./assets/images/user4.jpg",
        name: "Mohammad Zitoun",
        tagname: "MohammadZitoun",
        connect: "http://www.google.com"
    },{
        id: 5,
        photo: "./assets/images/user5.jpg",
        name: "Ricky Ponting",
        tagname: "RickyPonting",
        connect: "http://www.google.com"
    },{
        id: 6,
        photo: "./assets/images/user2.jpg",
        name: "Seary Victor",
        tagname: "SearyVictor",
        connect: "http://www.google.com"
    },{
        id: 7,
        photo: "./assets/images/user3.jpg",
        name: "John Steere",
        tagname: "JohnSteere",
        connect: "http://www.google.com"
    },{
        id: 8,
        photo: "./assets/images/user4.jpg",
        name: "Mohammad Zitoun",
        tagname: "MohammadZitoun",
        connect: "http://www.google.com"
    }
]

function SuggestUsers() {

    const { currentUser } = useSelector((state) => ({
        currentUser: state.profile.currentUser,
    }));
    const [suggestedUsers,setSuggestedUsers]=useState([])
    function getUserData(uid) {
        return new Promise((resolve, reject) => {
            return database.ref("users/" + uid).once("value", (snap) => {
                resolve(snap.val());
            });
        });
    }
    function getUsers() {
        return database
            .ref(`/users/${currentUser.genre}`)
            .orderByChild(`genre`)
            .once("value")
            .then(async (snapshot) => {

                    const array = [];
                    snapshot.forEach((childSnapshot) => {
                        array.push(childSnapshot.key);
                    });

                    const results = await Promise.all(
                        array.map(async (uid, i) => {
                            const data = await getUserData(uid);
                            return { uid, user_details: data }
                        })
                    );
                setSuggestedUsers(results)
                }
            )
    }

    useEffect(() => {
        getUsers();
    }, [])

    return (
        <section className="py-3">
            <div className="container mx-0 px-0">
                <div className="row flex-nowrap" style={{overflow:'hidden', overflowX:'auto'}}>
                    <ul className="suggestedusers">
                    {
                        suggestedUsers.map((suggested) =>
                        <div className="col py-3" key={suggested.uid} style={{minWidth:'220px',maxWidth:'220px'}}>
                            <div className="card rounded-xl border-0 shadow-sm text-center overflow-hidden h-100">
                                <div className="card-body">
                                    <div className="mmwh-80 overflow-hidden rounded-pill ratio ratio-1x1 mx-auto">
                                        <img src={suggested.user_details} alt="avatar"/>
                                    </div>
                                    <h6 className="fw-semibold mt-3 mb-1">{suggested.user_details}</h6>
                                    <p className="fs-13 fw-medium text-muted mb-1">@{suggested.user_details}</p>
                                </div>
                                <div className="card-footer p-3 bg-white">
                                    {/*<Link to={suggested.user_details.connect} className="btn btn-secondary rounded-pill fw-semibold px-4">Connect</Link>*/}
                                </div>
                            </div>
                        </div>

                        )
                    }
                    </ul>
                </div>
            </div>
        </section>
    )
}

export default SuggestUsers;